import React from 'react';

/**
 * @return {string}
 */
export function CheckEmptyDialogFlashCardField(items){
    for(let i = 0; i < items.length; i++ ) {
        if(items[i].question === ''){
            return 'Speaker A labels cannot be left blank'
        } else if(items[i].response === '') {
            return 'Speaker B labels cannot be left blank'

        } else if(items[i].englishQuestion === '') {
            return 'Translation for speaker A labels cannot be left blank'

        } else if(items[i].englishResponse === '') {
            return 'Translation for speaker B labels cannot be left blank'

        }
    }
    return '';
}
